// Australian suburbs to postcode mapping - Expanded database
// Comprehensive list of Australian suburbs across all states and territories
export const australianSuburbs = [
  // NSW - Sydney Metro & Greater Sydney
  { suburb: "Sydney", postcode: "2000", state: "NSW" },
  { suburb: "Parramatta", postcode: "2150", state: "NSW" },
  { suburb: "Liverpool", postcode: "2170", state: "NSW" },
  { suburb: "Penrith", postcode: "2750", state: "NSW" },
  { suburb: "Bondi", postcode: "2026", state: "NSW" },
  { suburb: "Bondi Beach", postcode: "2026", state: "NSW" },
  { suburb: "Bondi Junction", postcode: "2022", state: "NSW" },
  { suburb: "Manly", postcode: "2095", state: "NSW" },
  { suburb: "Chatswood", postcode: "2067", state: "NSW" },
  { suburb: "Blacktown", postcode: "2148", state: "NSW" },
  { suburb: "Campbelltown", postcode: "2560", state: "NSW" },
  { suburb: "Bankstown", postcode: "2200", state: "NSW" },
  { suburb: "Hornsby", postcode: "2077", state: "NSW" },
  { suburb: "Sutherland", postcode: "2232", state: "NSW" },
  { suburb: "Ryde", postcode: "2112", state: "NSW" },
  { suburb: "North Sydney", postcode: "2060", state: "NSW" },
  { suburb: "Cronulla", postcode: "2230", state: "NSW" },
  { suburb: "Dee Why", postcode: "2099", state: "NSW" },
  { suburb: "Hurstville", postcode: "2220", state: "NSW" },
  { suburb: "Fairfield", postcode: "2165", state: "NSW" },
  { suburb: "Strathfield", postcode: "2135", state: "NSW" },
  { suburb: "Castle Hill", postcode: "2154", state: "NSW" },
  { suburb: "Newtown", postcode: "2042", state: "NSW" },
  { suburb: "Randwick", postcode: "2031", state: "NSW" },
  { suburb: "Pyrmont", postcode: "2009", state: "NSW" },
  { suburb: "Balmain", postcode: "2041", state: "NSW" },
  { suburb: "Leichhardt", postcode: "2040", state: "NSW" },
  { suburb: "Mosman", postcode: "2088", state: "NSW" },
  { suburb: "Epping", postcode: "2121", state: "NSW" },
  { suburb: "Ashfield", postcode: "2131", state: "NSW" },
  
  // NSW - Regional
  { suburb: "Newcastle", postcode: "2300", state: "NSW" },
  { suburb: "Wollongong", postcode: "2500", state: "NSW" },
  { suburb: "Central Coast", postcode: "2250", state: "NSW" },
  { suburb: "Gosford", postcode: "2250", state: "NSW" },
  { suburb: "Wyong", postcode: "2259", state: "NSW" },
  { suburb: "Port Macquarie", postcode: "2444", state: "NSW" },
  { suburb: "Laurieton", postcode: "2443", state: "NSW" },
  { suburb: "Taree", postcode: "2430", state: "NSW" },
  { suburb: "Kempsey", postcode: "2440", state: "NSW" },
  { suburb: "Forster", postcode: "2428", state: "NSW" },
  { suburb: "Coffs Harbour", postcode: "2450", state: "NSW" },
  { suburb: "Dubbo", postcode: "2830", state: "NSW" },
  { suburb: "Wagga Wagga", postcode: "2650", state: "NSW" },
  { suburb: "Albury", postcode: "2640", state: "NSW" },
  { suburb: "Tamworth", postcode: "2340", state: "NSW" },
  { suburb: "Orange", postcode: "2800", state: "NSW" },
  { suburb: "Bathurst", postcode: "2795", state: "NSW" },
  { suburb: "Lismore", postcode: "2480", state: "NSW" },
  { suburb: "Nowra", postcode: "2541", state: "NSW" },
  { suburb: "Queanbeyan", postcode: "2620", state: "NSW" },
  { suburb: "Cessnock", postcode: "2325", state: "NSW" },
  { suburb: "Grafton", postcode: "2460", state: "NSW" },
  { suburb: "Goulburn", postcode: "2580", state: "NSW" },
  { suburb: "Muswellbrook", postcode: "2333", state: "NSW" },
  { suburb: "Byron Bay", postcode: "2481", state: "NSW" },
  
  // VIC - Melbourne Metro
  { suburb: "Melbourne", postcode: "3000", state: "VIC" },
  { suburb: "Carlton", postcode: "3053", state: "VIC" },
  { suburb: "Fitzroy", postcode: "3065", state: "VIC" },
  { suburb: "St Kilda", postcode: "3182", state: "VIC" },
  { suburb: "Richmond", postcode: "3121", state: "VIC" },
  { suburb: "Brunswick", postcode: "3056", state: "VIC" },
  { suburb: "Footscray", postcode: "3011", state: "VIC" },
  { suburb: "Preston", postcode: "3072", state: "VIC" },
  { suburb: "Box Hill", postcode: "3128", state: "VIC" },
  { suburb: "Ringwood", postcode: "3134", state: "VIC" },
  { suburb: "Dandenong", postcode: "3175", state: "VIC" },
  { suburb: "Frankston", postcode: "3199", state: "VIC" },
  { suburb: "Werribee", postcode: "3030", state: "VIC" },
  { suburb: "Sunbury", postcode: "3429", state: "VIC" },
  { suburb: "Craigieburn", postcode: "3064", state: "VIC" },
  { suburb: "Melton", postcode: "3337", state: "VIC" },
  { suburb: "Pakenham", postcode: "3810", state: "VIC" },
  { suburb: "Mornington", postcode: "3931", state: "VIC" },
  { suburb: "South Yarra", postcode: "3141", state: "VIC" },
  { suburb: "Brighton", postcode: "3186", state: "VIC" },
  { suburb: "Essendon", postcode: "3040", state: "VIC" },
  { suburb: "Doncaster", postcode: "3108", state: "VIC" },
  { suburb: "Glen Waverley", postcode: "3150", state: "VIC" },
  { suburb: "Camberwell", postcode: "3124", state: "VIC" },
  { suburb: "Caulfield", postcode: "3162", state: "VIC" },
  
  // VIC - Regional
  { suburb: "Geelong", postcode: "3220", state: "VIC" },
  { suburb: "Ballarat", postcode: "3350", state: "VIC" },
  { suburb: "Bendigo", postcode: "3550", state: "VIC" },
  { suburb: "Shepparton", postcode: "3630", state: "VIC" },
  { suburb: "Wodonga", postcode: "3690", state: "VIC" },
  { suburb: "Warrnambool", postcode: "3280", state: "VIC" },
  { suburb: "Mildura", postcode: "3500", state: "VIC" },
  { suburb: "Traralgon", postcode: "3844", state: "VIC" },
  
  // QLD - Brisbane Metro
  { suburb: "Brisbane", postcode: "4000", state: "QLD" },
  { suburb: "Fortitude Valley", postcode: "4006", state: "QLD" },
  { suburb: "South Brisbane", postcode: "4101", state: "QLD" },
  { suburb: "West End", postcode: "4101", state: "QLD" },
  { suburb: "New Farm", postcode: "4005", state: "QLD" },
  { suburb: "Paddington", postcode: "4064", state: "QLD" },
  { suburb: "Indooroopilly", postcode: "4068", state: "QLD" },
  { suburb: "Chermside", postcode: "4032", state: "QLD" },
  { suburb: "Carindale", postcode: "4152", state: "QLD" },
  { suburb: "Sunnybank", postcode: "4109", state: "QLD" },
  { suburb: "Logan", postcode: "4114", state: "QLD" },
  { suburb: "Ipswich", postcode: "4305", state: "QLD" },
  { suburb: "Caboolture", postcode: "4510", state: "QLD" },
  { suburb: "Redcliffe", postcode: "4020", state: "QLD" },
  { suburb: "Cleveland", postcode: "4163", state: "QLD" },
  
  // QLD - Gold Coast & Sunshine Coast
  { suburb: "Gold Coast", postcode: "4217", state: "QLD" },
  { suburb: "Surfers Paradise", postcode: "4217", state: "QLD" },
  { suburb: "Southport", postcode: "4215", state: "QLD" },
  { suburb: "Broadbeach", postcode: "4218", state: "QLD" },
  { suburb: "Burleigh Heads", postcode: "4220", state: "QLD" },
  { suburb: "Coolangatta", postcode: "4225", state: "QLD" },
  { suburb: "Sunshine Coast", postcode: "4558", state: "QLD" },
  { suburb: "Maroochydore", postcode: "4558", state: "QLD" },
  { suburb: "Noosa", postcode: "4567", state: "QLD" },
  { suburb: "Caloundra", postcode: "4551", state: "QLD" },
  
  // QLD - Regional (User requested)
  { suburb: "Cairns", postcode: "4870", state: "QLD" },
  { suburb: "Townsville", postcode: "4810", state: "QLD" },
  { suburb: "Toowoomba", postcode: "4350", state: "QLD" },
  { suburb: "Rockhampton", postcode: "4700", state: "QLD" },
  { suburb: "Mackay", postcode: "4740", state: "QLD" },
  { suburb: "Bundaberg", postcode: "4670", state: "QLD" },
  { suburb: "Hervey Bay", postcode: "4655", state: "QLD" },
  { suburb: "Gladstone", postcode: "4680", state: "QLD" },
  { suburb: "Mount Isa", postcode: "4825", state: "QLD" },
  { suburb: "Dalby", postcode: "4405", state: "QLD" },
  { suburb: "Yeppoon", postcode: "4703", state: "QLD" },
  { suburb: "Maryborough", postcode: "4650", state: "QLD" },
  { suburb: "Warwick", postcode: "4370", state: "QLD" },
  { suburb: "Emerald", postcode: "4720", state: "QLD" },
  { suburb: "Kingaroy", postcode: "4610", state: "QLD" },
  { suburb: "Gympie", postcode: "4570", state: "QLD" },
  
  // WA - Perth Metro
  { suburb: "Perth", postcode: "6000", state: "WA" },
  { suburb: "Fremantle", postcode: "6160", state: "WA" },
  { suburb: "Joondalup", postcode: "6027", state: "WA" },
  { suburb: "Rockingham", postcode: "6168", state: "WA" },
  { suburb: "Mandurah", postcode: "6210", state: "WA" },
  { suburb: "Armadale", postcode: "6112", state: "WA" },
  { suburb: "Midland", postcode: "6056", state: "WA" },
  { suburb: "Cannington", postcode: "6107", state: "WA" },
  { suburb: "Morley", postcode: "6062", state: "WA" },
  { suburb: "Subiaco", postcode: "6008", state: "WA" },
  { suburb: "Victoria Park", postcode: "6100", state: "WA" },
  { suburb: "Scarborough", postcode: "6019", state: "WA" },
  { suburb: "Cottesloe", postcode: "6011", state: "WA" },
  
  // WA - Regional
  { suburb: "Bunbury", postcode: "6230", state: "WA" },
  { suburb: "Geraldton", postcode: "6530", state: "WA" },
  { suburb: "Kalgoorlie", postcode: "6430", state: "WA" },
  { suburb: "Albany", postcode: "6330", state: "WA" },
  { suburb: "Busselton", postcode: "6280", state: "WA" },
  
  // SA - Adelaide Metro
  { suburb: "Adelaide", postcode: "5000", state: "SA" },
  { suburb: "North Adelaide", postcode: "5006", state: "SA" },
  { suburb: "Glenelg", postcode: "5045", state: "SA" },
  { suburb: "Elizabeth", postcode: "5112", state: "SA" },
  { suburb: "Gawler", postcode: "5118", state: "SA" },
  { suburb: "Salisbury", postcode: "5108", state: "SA" },
  { suburb: "Modbury", postcode: "5092", state: "SA" },
  { suburb: "Marion", postcode: "5043", state: "SA" },
  { suburb: "Norwood", postcode: "5067", state: "SA" },
  
  // SA - Regional
  { suburb: "Mount Gambier", postcode: "5290", state: "SA" },
  { suburb: "Whyalla", postcode: "5600", state: "SA" },
  { suburb: "Murray Bridge", postcode: "5253", state: "SA" },
  { suburb: "Port Augusta", postcode: "5700", state: "SA" },
  { suburb: "Port Lincoln", postcode: "5606", state: "SA" },
  { suburb: "Port Pirie", postcode: "5540", state: "SA" },
  { suburb: "Victor Harbor", postcode: "5211", state: "SA" },
  
  // TAS - All Major Areas
  { suburb: "Hobart", postcode: "7000", state: "TAS" },
  { suburb: "Launceston", postcode: "7250", state: "TAS" },
  { suburb: "Devonport", postcode: "7310", state: "TAS" },
  { suburb: "Burnie", postcode: "7320", state: "TAS" },
  { suburb: "Kingston", postcode: "7050", state: "TAS" },
  { suburb: "Ulverstone", postcode: "7315", state: "TAS" },
  { suburb: "Glenorchy", postcode: "7010", state: "TAS" },
  { suburb: "Clarence", postcode: "7163", state: "TAS" },
  
  // ACT - All Major Areas
  { suburb: "Canberra", postcode: "2600", state: "ACT" },
  { suburb: "Belconnen", postcode: "2617", state: "ACT" },
  { suburb: "Tuggeranong", postcode: "2900", state: "ACT" },
  { suburb: "Woden", postcode: "2606", state: "ACT" },
  { suburb: "Gungahlin", postcode: "2912", state: "ACT" },
  { suburb: "Civic", postcode: "2601", state: "ACT" },
  { suburb: "Braddon", postcode: "2612", state: "ACT" },
  { suburb: "Dickson", postcode: "2602", state: "ACT" },
  
  // NT - All Major Areas
  { suburb: "Darwin", postcode: "0800", state: "NT" },
  { suburb: "Alice Springs", postcode: "0870", state: "NT" },
  { suburb: "Palmerston", postcode: "0830", state: "NT" },
  { suburb: "Katherine", postcode: "0850", state: "NT" },
  { suburb: "Casuarina", postcode: "0810", state: "NT" },
  { suburb: "Nightcliff", postcode: "0810", state: "NT" },
];

// Function to find postcode by suburb name
export const getPostcodeBySuburb = (suburbName) => {
  const normalizedInput = suburbName.toLowerCase().trim();
  const match = australianSuburbs.find(
    item => item.suburb.toLowerCase() === normalizedInput
  );
  return match ? { postcode: match.postcode, state: match.state } : null;
};

// Function to get suburb suggestions for autocomplete
// Searches by both suburb name AND postcode
export const getSuburbSuggestions = (input) => {
  if (!input || input.length < 2) return [];
  
  const normalizedInput = input.toLowerCase().trim();
  
  // Check if input looks like a postcode (starts with numbers)
  const isPostcodeSearch = /^\d/.test(normalizedInput);
  
  if (isPostcodeSearch) {
    // Search by postcode - show suburbs that match the postcode prefix
    return australianSuburbs
      .filter(item => item.postcode.startsWith(normalizedInput))
      .slice(0, 15); // Show more results for postcode searches
  } else {
    // Search by suburb name
    return australianSuburbs
      .filter(item => item.suburb.toLowerCase().startsWith(normalizedInput))
      .slice(0, 10);
  }
};

// Function to find nearest suburbs based on geolocation coordinates
export const getNearestSuburbs = async (latitude, longitude) => {
  // This is a simplified version. In production, you'd use a geolocation API
  // For now, we'll return some default suggestions based on rough coordinates
  
  // Rough coordinate ranges for major cities
  const cityRanges = {
    sydney: { lat: [-34.2, -33.5], lng: [150.5, 151.5] },
    melbourne: { lat: [-38.2, -37.5], lng: [144.5, 145.5] },
    brisbane: { lat: [-27.8, -27.1], lng: [152.5, 153.5] },
    perth: { lat: [-32.2, -31.5], lng: [115.5, 116.5] },
    adelaide: { lat: [-35.2, -34.5], lng: [138.0, 139.0] },
    canberra: { lat: [-35.6, -35.0], lng: [148.8, 149.5] },
  };
  
  // Check which city range the coordinates fall into
  for (const [city, range] of Object.entries(cityRanges)) {
    if (latitude >= range.lat[0] && latitude <= range.lat[1] &&
        longitude >= range.lng[0] && longitude <= range.lng[1]) {
      
      // Return suburbs from that city
      const citySuburbs = {
        sydney: ["Sydney", "Parramatta", "Bondi", "Manly"],
        melbourne: ["Melbourne", "St Kilda", "Richmond", "Brunswick"],
        brisbane: ["Brisbane", "Fortitude Valley", "South Brisbane"],
        perth: ["Perth", "Fremantle", "Joondalup"],
        adelaide: ["Adelaide", "Glenelg", "North Adelaide"],
        canberra: ["Canberra", "Belconnen", "Gungahlin"],
      };
      
      const suburbNames = citySuburbs[city] || [];
      return australianSuburbs.filter(s => suburbNames.includes(s.suburb));
    }
  }
  
  // Default: return most populous suburbs
  return australianSuburbs.slice(0, 5);
};
